export const PLAN_FEATURES = {
  BASE_PERMISSION: 1,
  BILLINGS: 2,
  MEETING_ROOMS: 4,
  TICKETS: 8,
  PRINTERS: 16,
  LOCKS: 32,
  AI: 64,
  TG: 128,
} as const;

export const FEATURE_NAMES = {
  [PLAN_FEATURES.BASE_PERMISSION]: "Базовые права",
  [PLAN_FEATURES.BILLINGS]: "Финансы",
  [PLAN_FEATURES.MEETING_ROOMS]: "Переговорки",
  [PLAN_FEATURES.TICKETS]: "Тикеты",
  [PLAN_FEATURES.PRINTERS]: "Печать",
  [PLAN_FEATURES.LOCKS]: "СКУД",
  [PLAN_FEATURES.AI]: "AI-модули",
  [PLAN_FEATURES.TG]: "TG-бот",
} as const;

export type PlanFeature = (typeof PLAN_FEATURES)[keyof typeof PLAN_FEATURES];
